import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useSetAtom } from 'jotai';
import {
  getArticlePriceData,
  getInventoryArticleType,
  nextQuantity,
  useParameters,
} from '@web/utils/src';
import cartIconDark from '@web/utils/src/assets/icons/functions/cart-icon-dark.svg';
import plusIcon from '@web/utils/src/assets/icons/functions/plus-icon.svg';
import { useCustomToast } from '@/hooks/useCustomToast';
import { isCartOpenAtom, newCartItemAtom } from '@/store/atoms';
import { addToCartAtom } from '@/store/store';
import { Article } from '@/types';
import { AddToCartToast } from '../AddToCartToast';

export interface AddToCartButtonProps {
  article: Article;
  quantityInCart: number;
}

interface CartParams {
  retailerId: string;
}

const AddToCartButton = (props: AddToCartButtonProps) => {
  const setCartItems = useSetAtom(addToCartAtom);
  const newCartItem = useSetAtom(newCartItemAtom);
  const setCartOpen = useSetAtom(isCartOpenAtom);
  const { retailerId } = useParameters<CartParams>();
  const { t } = useTranslation();

  const { article, quantityInCart } = props;
  const itemType = getInventoryArticleType(article);
  const { finalPrice } = getArticlePriceData(article);
  const customToast = useCustomToast();

  const HandleClick = () => {
    let quantity = 1;

    if (itemType === 'loose' && article.amount) {
      const deliveryOptions = article.quantityOptions?.delivery;
      const incrementBy = nextQuantity(
        deliveryOptions as string[],
        quantityInCart,
      );
      quantity = incrementBy as number;
    }

    // previously this was handled conditionally and if price was falsy chat was initiated
    try {
      newCartItem(article);
      setCartItems({
        quantity,
        price: finalPrice,
        retailerID: retailerId,
      });
      toast(
        <AddToCartToast article={article} onClick={() => setCartOpen(true)} />,
        { duration: 3000, position: 'bottom-right' },
      );
    } catch (error: any) {
      customToast('error', error.message || t('global.something_went_wrong'));
    }
  };

  return (
    <div
      className="bg-primary-yellow rounded-base p-2-0 md:p-0-8 flex items-center gap-0-5 md:gap-1-0 cursor-pointer"
      onClick={HandleClick}
    >
      <img src={cartIconDark} alt="Cart" />
      <img src={plusIcon} alt="Plus" />
    </div>
  );
};

export default AddToCartButton;
